import { Submission } from '@/types'

export function sanitiseAuthorsEmails(submission: Submission) {
  if (!submission?.authors?.length) return

  submission.authors.forEach((author) => {
    if (author.email) {
      author.email = author.email
        .trim()
        .replace(/\.+@/, '@')
        .replace(/\.+$/, '')
    }
  })
}